:host {
    /**
    * @prop --focus-color: The color to outline the checkbox when hovered or focused, default to the dnn primary color.
    */
  --focus-color: var(--dnn-color-primary, #3792ED);
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin: 3px;
}
button{
  cursor: pointer; 
  background-color: transparent;
  border: 0;
  padding: 0;
  margin: 0;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  .unchecked, .checked, .intermediate{
    display: none;
  }
  &.checked .checked, &.unchecked .unchecked, &.intermediate .intermediate{
    display: block;
  }
  svg.undefined{
    opacity: 0.45;
    cursor: default;
  }
  &:focus-visible{
    box-shadow: 0 0 2px 2px var(--focus-color);
  }
  &.invalid{
    border: 2px solid var(--dnn-color-danger);
  }
}
label {
  cursor: pointer; 
}